import axios from "axios";

const API = axios.create({
  baseURL: "https://api.ilogically.com/api/email", // adjust if needed
 
});

export const emailTemplateService = {

  list() {
    return API.get("/templates");
  },

  create(payload) {
    return API.post("/templates", payload);
  },

  update(id, payload) {
    return API.put(`/templates/${id}`, payload);
  },

  updateStatus(id, isActive) {
    return API.patch(`/templates/${id}/status`, { isActive });
  }
};